import { Router } from '@angular/router';
import { Component } from '@angular/core';

import { routeNames } from '../../../../shared/route-names';
import { UserService } from '../../../user/services/user.service';

@Component({
  standalone: false,
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
})
export class LogoutComponent {
  constructor(private _userService: UserService, private _router: Router) {
    this._userService.logout().subscribe(() => {
      this._router.navigate([routeNames.root]);
    });
  }
}
